import * as leadformConstants from '../constants';
import '../../../principles/polyfills/closest';

// Gets the Panel associated with an element
export default function getPanel(element) {
  return element.closest(leadformConstants.leadformClasses.panel);
}



// WEBPACK FOOTER //
// ./client/app/scripts/leadform/models/element/get_panel.js